import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ButtonsContainer, Text } from 'components/common/Elements/Elements';

import classes from './FooterModalCustomers.module.scss';

const FooterModalCustomers = ({ counter = 0, handleCancel, handleRollout }) => {
  const { t } = useTranslation(['activity']);

  return (
    <div className={classes.modal}>
      <div className={classes.wrap}>
        <div className={classes.counterWrap}>
          <Text className={classes.counter}>{counter}</Text>
        </div>
        <Text className={classes.description}>Customers selected</Text>
      </div>
      <ButtonsContainer
        handleCancel={handleCancel}
        handleOpenModal={handleRollout}
        action={t('activity:agentRollout.ROLLOUT_FOR_SELECTED')}
      />
    </div>
  );
};

FooterModalCustomers.propTypes = {
  counter: PropTypes.number,
  handleCancel: PropTypes.func,
  handleRollout: PropTypes.func
};

export default FooterModalCustomers;
